export const baseColors = {
  black: {
    10: '#1C1C1C',
    20: '#333232',
    30: '#525252',
    40: '#8A8988',
    50: '#B1B0AE',
    60: '#C9C8C5',
    70: '#E4E2DF',
    80: '#F2F1EF',
    90: '#F9F8F6',
    100: '#FDFEFF',
  },
  blue: {
    10: '#03202E',
    20: '#0F2E4D',
    30: '#155A82',
    40: '#388EBB',
    50: '#51B0E0',
    60: '#73C0E6',
    70: '#8ECDEC',
    80: '#AADAF3',
    90: '#D4EDF9',
  },
  purple: {
    10: '#372553',
    20: '#5A377E',
    30: '#7C4DA8',
    40: '#9F63D3',
    50: '#C075FE',
    60: '#CD91FE',
    70: '#D9ACFE',
    80: '#E6C8FF',
    90: '#F2E3FF',
  },
  pink: {
    10: '#471F3D',
    20: '#723255',
    30: '#9C456E',
    40: '#C75084',
    50: '#F2639F',
    60: '#58282B',
    70: '#F7A1C5',
    80: '#FAC1D9',
    90: '#FCE0EC',
  },
  red: {
    10: '#471F2D',
    20: '#72303B',
    30: '#9C3B45',
    40: '#C74C55',
    50: '#F25C64',
    60: '#F57D83',
    70: '#F79DA2',
    80: '#FABEC1',
    90: '#FCDEEC',
  },
  orange: {
    10: '#472027',
    20: '#723E32',
    30: '#9C503E',
    40: '#C7614A',
    50: '#F2785C',
    60: '#F5977D',
    70: '#F7B19D',
    80: '#FACCBE',
    90: '#FCE5DE',
  },
  yellow: {
    10: '#493E28',
    20: '#775F2B',
    30: '#A48231',
    40: '#D9AC3B',
    50: '#FFCF44',
    60: '#FFD969',
    70: '#FFE28F',
    80: '#FFECB4',
    90: '#FFF5DA',
  },
  green: {
    10: '#233C35',
    20: '#265849',
    30: '#29755E',
    40: '#2C9172',
    50: '#2FAD87',
    60: '#58BD9F',
    70: '#81CDB7',
    80: '#ABDECF',
    90: '#D4EEE7',
  },
}
